class Mark {
    constructor (mark) {
        this.mark = mark;
    }

    matching () {
        return false;
    }

    tag () {
        return null;
    }
}

module.exports = Mark;